import { render } from "./MinusCircle.vue?vue&type=template&id=c9a6ec24"
import script from "./MinusCircle.vue?vue&type=script&lang=js"
export * from "./MinusCircle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "c9a6ec24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9a6ec24', script)) {
    api.reload('c9a6ec24', script)
  }
  
  module.hot.accept("./MinusCircle.vue?vue&type=template&id=c9a6ec24", () => {
    api.rerender('c9a6ec24', render)
  })

}

script.__file = "src/icons/components/outlined/MinusCircle.vue"

export default script